import { useState, useEffect } from "react";
import './style.css';
import IconNora from "../../images/nora-icon.png";

const FEEDBACK_STAGES = [
  { text: "Reviewing your responses…", ms: 6000 },
  { text: "Scoring your overall performance…", ms: 8000 },
  { text: "Analyzing your soft skills and communication…", ms: 8000 },
  { text: "Going through your answers question by question…", ms: 25000 },
  { text: "Lining up your next mock interviews…", ms: 8000 },
  { text: "Writing up your personalized report…", ms: null },
];

const FeedbackLoader = () => {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const duration = FEEDBACK_STAGES[stage].ms;
    if (duration == null) return; // final stage: hold until feedback arrives
    const id = setTimeout(
      () => setStage((s) => Math.min(s + 1, FEEDBACK_STAGES.length - 1)),
      duration
    );
    return () => clearTimeout(id);
  }, [stage]);

  return (
    <div className="nora-fb-overlay">
      <div className="nora-fb-loader">
        <div className="nora-fb-orbit">
          <span className="nora-fb-ring" />
          <span className="nora-fb-trail" />
          <span className="nora-fb-dot" />
          <span className="nora-fb-core">
            <img src={IconNora} alt="Nora" />
          </span>
        </div>

        <div className="nora-fb-meta">
          <span className="nora-fb-eta">Feedback generation: ~2 min</span>
          <h2 className="nora-fb-title">Generating your feedback</h2>
          <p className="nora-fb-stage" key={stage}>
            {FEEDBACK_STAGES[stage].text}
          </p>
        </div>

        <div className="nora-fb-pips">
          {FEEDBACK_STAGES.map((_, i) => (
            <span
              key={i}
              className={
                "nora-fb-pip" +
                (i < stage ? " is-done" : "") +
                (i === stage ? " is-active" : "")
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeedbackLoader;